export enum ActiveTab {
    Profile = "profile",
    Revenues = "revenues",
    EnrolledCourses = "EnrolledCourses",
}
